import { Organization } from '@/types/organization';
import { OptionType } from '@/ui/components/Form/Select/types';

export const formatOrganizationToSelectOption = (
  organization?: Organization | null
): OptionType<string> => {
  if (!organization) {
    return { label: '', value: '' };
  }
  return {
    label: organization.name,
    value: organization.id
  };
};

export default formatOrganizationToSelectOption;
